export class DialogUnlockFolderResponseData {
	/**
	 * Constructeur.
	 */
	public constructor(
		public userName: string,
		public folderName: string,
		public accept: boolean
	) {}
}
